import React, { useEffect } from "react";
import Header from "../components/Header";
import "./css/PrivacyPolicy.css";
import Footer from "../components/Footer";


export default function PrivacyPolicy() {
	useEffect(() => {

	}, []);

	return (
		<>
			<div className="App">
				<Header />
				<div className="container">
					<div className="row">
						<div className="col-12">
							
							<div className="policyMainArea">
								<h1>Privacy Policy</h1>
							
							<section>
								<p>
									Rupin Consultancy ("Rupin Consultancy", "we", "us", or "our")
									respects your privacy and is committed to protecting the personal
									information we collect and process through our website, mobile
									applications, and related services.
								</p>

								<p>
									This Privacy Policy explains what information we collect, why we
									collect it, how we use and share it, how we protect it, and the
									choices available to you.
								</p>

								<p>
									This Privacy Policy applies to:
								</p>

								<ul>
									<li>The Rupin AI website, including <strong>rupin.ai</strong>;</li>
									<li>Rupin AI mobile applications;</li>
									<li>
										Services and features provided through our website or
										applications; and
									</li>
									<li>
										Other services that link to or expressly refer to this
										Privacy Policy.
									</li>
								</ul>

								<p>
									By accessing or using our Services, you acknowledge that you have
									read and understood this Privacy Policy.
								</p>
							</section>

							<section>
								<h2>1. About Rupin AI</h2>

								<p>
									Rupin AI provides technology-enabled products and services,
									including home automation, window-treatment solutions, order
									management, installation, and onsite customer services.
								</p>

								<p>
									Our mobile application may be used by authorized employees,
									field-service personnel, sales personnel, installers, and other
									authorized users to manage business activities such as:
								</p>

								<ul>
									<li>Customer orders;</li>
									<li>Customer visits;</li>
									<li>Installation and service appointments;</li>
									<li>Order and service status;</li>
									<li>Assignment of field activities;</li>
									<li>Customer and site information;</li>
									<li>Service documentation; and</li>
									<li>Onsite visit verification.</li>
								</ul>
							</section>

							<section>
								<h2>2. Information We Collect</h2>

								<p>
									Depending on the Services and features you use, we may collect
									the following categories of information.
								</p>

								<h3>2.1 Account and User Information</h3>

								<p>
									When an account is created or used, we may collect:
								</p>

								<ul>
									<li>Name;</li>
									<li>Mobile phone number;</li>
									<li>Email address;</li>
									<li>User or employee ID;</li>
									<li>Login and authentication information;</li>
									<li>User role or department;</li>
									<li>Profile information; and</li>
									<li>Information provided by an authorized administrator.</li>
								</ul>


								<h3>2.2 Customer and Order Information</h3>

								<p>
									When our Services are used to manage orders or customer services,
									we may process:
								</p>

								<ul>
									<li>Customer name;</li>
									<li>Customer phone number;</li>
									<li>Customer email address;</li>
									<li>Customer address;</li>
									<li>Installation or service address;</li>
									<li>Order details;</li>
									<li>Products and services ordered;</li>
									<li>Appointment information;</li>
									<li>Service and installation details;</li>
									<li>Order and service status;</li>
									<li>Notes entered by authorized users; and</li>
									<li>
										Photographs, documents, signatures, or other information
										submitted in connection with an order or service.
									</li>
								</ul>
							</section>

							<section>
								<h2>3. Location Information</h2>

								<h3>3.1 Location Information We Collect</h3>

								<p>
									The Rupin AI mobile application may collect the physical location
									of authorized employees, technicians, and field-service
									personnel using location services available on their mobile
									device.
								</p>

								<p>
									Depending on the device, operating system, permissions granted,
									and application functionality, the information collected may
									include:
								</p>

								<ul>
									<li>Precise device location;</li>
									<li>Approximate device location;</li>
									<li>GPS coordinates;</li>
									<li>Date and time associated with a location record;</li>
									<li>Location history associated with field-service activities;</li>
									<li>
										Location information associated with assigned customers,
										orders, installations, and service visits; and
										
											Other location information necessary to support technician
											tracking and field-service operations.
										</li>
								</ul>


								<h3>3.2 Why We Collect Technician Location</h3>

								<p>
									Location information is used as part of our field-service and
									technician-management functionality.
								</p>

								<p>
									We may use technician location information to:
								</p>

								<ul>
									<li>
										Allow authorized personnel to determine the current location
										of assigned technicians;
									</li>
									<li>
										Coordinate technicians with customer appointments and
										service assignments;
									</li>
									<li>
										Monitor technician movement during assigned field-service
										activities;
									</li>
									<li>
										Determine a technician's proximity to an assigned customer
										or service location;
									</li>
									<li>
										Support scheduling and dispatch of field-service personnel;
									</li>
									<li>
										Verify arrival at or departure from customer or service
										locations;
									</li>
									<li>
										Maintain records of onsite service activities;
									</li>
									<li>
										Improve coordination and response times for customer service;
									</li>
									<li>
										Investigate service-related disputes or discrepancies; and
									</li>
									<li>
										Maintain operational, security, and audit records.
									</li>
								</ul>

								<p>
									<strong>Important:</strong>
									Technician location is collected for field-service and
									operational purposes. We do not sell location information and
									do not use technician location information for advertising or
									targeted advertising.
								</p>


								<h3>3.3 Background and Continuous Location Collection</h3>

								<p>
									Because technician location is used to support field-service
									operations, the Rupin AI mobile application may collect location
									information while the application is running in the background,
									including when the application is minimized or, where technically
									applicable, when the application is closed or not actively being
									used.
								</p>

								<p>
									Background location collection allows authorized personnel to
									view and coordinate the location of technicians without requiring
									the technician to keep the Rupin AI application continuously open
									on the screen.
								</p>

								<p>
									Background location access is used for technician tracking,
									field-service coordination, customer visits, installations,
									service activities, and other related operational functionality.
								</p>


								<h3>3.4 Location Permissions</h3>

								<p>
									The application may request approximate or precise location
									permission depending on the requirements of the relevant
									field-service functionality.
								</p>

								<p>
									Where background location is required, the application may
									request the corresponding Android background location permission
									or use an applicable Android foreground-service mechanism,
									depending on the implementation.
								</p>

								<p>
									Location permissions are controlled by the operating system of
									your device. You may grant, deny, or revoke location permissions
									through your device settings.
								</p>

								<p>
									If location permission is denied or disabled, technician
									tracking and other location-dependent field-service
									functionality may not work correctly.
								</p>


								<h3>3.5 Who Can Access Technician Location</h3>

								<p>
									Technician location information may be accessible to authorized
									personnel of Rupin Consultancy who require access for legitimate
									business and operational purposes.
								</p>

								<p>
									This may include authorized personnel responsible for:
								</p>

								<ul>
									<li>Field-service management;</li>
									<li>Technician scheduling and dispatch;</li>
									<li>Customer order management;</li>
									<li>Installation and service coordination;</li>
									<li>Customer support;</li>
									<li>Operational management; and</li>
									<li>Security, compliance, or audit activities.</li>
								</ul>

								<p>
									Access to location information is restricted according to the
									responsibilities of the relevant personnel.
								</p>


								<h3>3.6 Transmission of Location Information</h3>

								<p>
									Location information collected by the mobile application may be
									transmitted to Rupin Consultancy's servers or authorized
									technology infrastructure over secure network connections.
								</p>

								<p>
									Location information may be associated with the technician's
									account, assigned orders, customer visits, service activities,
									and relevant date and time information.
								</p>


								<h3>3.7 Location Data Retention</h3>

								<p>
									We retain technician location information only for as long as
									reasonably necessary for the purposes described in this Privacy
									Policy.
								</p>

								<p>
									Retention may depend on operational requirements, customer-service
									requirements, security, audit requirements, legal obligations,
									dispute resolution, and other legitimate business purposes.
								</p>

								<p>
									When location information is no longer required, we may delete,
									anonymize, or securely dispose of it, subject to applicable legal
									and regulatory requirements.
								</p>


								<h3>3.8 No Advertising Use</h3>

								<p>
									Technician location information is not used to serve advertising,
									targeted advertising, or promotional advertisements based on the
									technician's location.
								</p>
							</section>

							<section>
								<h2>4. How We Use Personal Information</h2>

								<p>
									We may use personal information for the following purposes:
								</p>

								<ul>
									<li>Creating and managing user accounts;</li>
									<li>Authenticating users;</li>
									<li>Providing and operating our Services;</li>
									<li>Processing and managing customer orders;</li>
									<li>Managing installations and service requests;</li>
									<li>Assigning and coordinating field-service activities;</li>
									<li>Recording and verifying onsite visits;</li>
									<li>
										Communicating with customers, employees, and authorized
										users;
									</li>
									<li>Providing customer and technical support;</li>
									<li>
										Processing information submitted through our applications;
									</li>
									<li>Maintaining business and operational records;</li>
									<li>
										Detecting and preventing fraud, misuse, or unauthorized
										access;
									</li>
									<li>Maintaining the security of our systems;</li>
									<li>
										Troubleshooting and resolving technical problems;
									</li>
									<li>
										Improving the performance and reliability of our Services;
									</li>
									<li>Complying with applicable legal obligations; and</li>
									<li>
										Protecting our legal rights and interests.
									</li>
								</ul>
							</section>

							<section>
								<h2>5. Information Sharing and Disclosure</h2>

								<p>
									We do not sell personal information.
								</p>

								<p>
									We may disclose or provide access to personal information only
									when reasonably necessary for the purposes described in this
									Privacy Policy.
								</p>


								<h3>5.1 Authorized Personnel</h3>

								<p>
									Authorized employees, managers, administrators, and other
									personnel may access information necessary to perform their
									responsibilities.
								</p>

								<p>
									This may include customer, order, service, visit, and location
									information.
								</p>


								<h3>5.2 Service Providers</h3>

								<p>
									We may use third-party service providers to operate and maintain
									our Services.
								</p>

								<p>
									These providers may provide services such as:
								</p>

								<ul>
									<li>Cloud hosting;</li>
									<li>Database infrastructure;</li>
									<li>Data storage;</li>
									<li>Authentication;</li>
									<li>Application infrastructure;</li>
									<li>Security;</li>
									<li>Error monitoring;</li>
									<li>Communication services;</li>
									<li>Notifications; and</li>
									<li>Technical support.</li>
								</ul>

								<p>
									Such providers may process information on our behalf and are
									expected to implement appropriate safeguards for the information
									they process.
								</p>


								<h3>5.3 Legal and Regulatory Requirements</h3>

								<p>
									We may disclose information when reasonably necessary to:
								</p>

								<ul>
									<li>Comply with applicable laws or regulations;</li>
									<li>
										Respond to lawful requests from government authorities;
									</li>
									<li>Protect our rights or property;</li>
									<li>
										Investigate fraud, abuse, or security incidents;
									</li>
									<li>Enforce our agreements; or</li>
									<li>
										Protect the safety, rights, or property of users or other
										persons.
									</li>
								</ul>
							</section>

							<section>
								<h2>6. Photos, Documents and Other Content</h2>

								<p>
									Certain features of our mobile application may allow authorized
									users to submit photographs, documents, signatures, notes, or
									other content relating to customer orders and service activities.
								</p>

								<p>
									Such information may be used to:
								</p>

								<ul>
									<li>Document installation or service work;</li>
									<li>Record the condition of a product or site;</li>
									<li>Verify completion of work;</li>
									<li>Maintain customer order records;</li>
									<li>Resolve service issues; and</li>
									<li>Perform other legitimate business activities.</li>
								</ul>

								<p>
									We process such content only for legitimate purposes related to
									the Services.
								</p>
							</section>

							<section>
								<h2>7. Device and Technical Information</h2>

								<p>
									When you use our mobile application or website, we may
									automatically receive certain technical information, which may
									include:
								</p>

								<ul>
									<li>Device type and model;</li>
									<li>Operating system and version;</li>
									<li>Application version;</li>
									<li>IP address;</li>
									<li>Device or application identifiers where necessary;</li>
									<li>Network information;</li>
									<li>Crash reports;</li>
									<li>Diagnostic information;</li>
									<li>Log information; and</li>
									<li>Information about application performance.</li>
								</ul>

								<p>
									We use this information for security, troubleshooting, analytics,
									maintenance, and improvement of our Services.
								</p>
							</section>

							<section>
								<h2>8. Notifications</h2>

								<p>
									Our mobile application may send notifications relating to:
								</p>

								<ul>
									<li>New assignments;</li>
									<li>Customer orders;</li>
									<li>Service appointments;</li>
									<li>Installation activities;</li>
									<li>Order updates;</li>
									<li>Service updates;</li>
									<li>Account or security events; and</li>
									<li>Important operational communications.</li>
								</ul>

								<p>
									You may control notification permissions through your device
									settings where supported.
								</p>
							</section>

							<section>
								<h2>9. Cookies and Similar Technologies</h2>

								<p>
									Our website may use cookies and similar technologies to:
								</p>

								<ul>
									<li>Operate and secure the website;</li>
									<li>Remember user preferences;</li>
									<li>Understand website usage;</li>
									<li>Improve website performance;</li>
									<li>Analyze traffic and usage; and</li>
									<li>Provide relevant website functionality.</li>
								</ul>

								<p>
									You can manage or disable cookies through your browser settings,
									although doing so may affect certain website features.
								</p>
							</section>

							<section>
								<h2>10. Data Security</h2>

								<p>
									We take reasonable technical and organizational measures to
									protect personal information against unauthorized access,
									disclosure, alteration, loss, misuse, or destruction.
								</p>

								<p>
									Depending on the nature of the information and the Services
									involved, these measures may include:
								</p>

								<ul>
									<li>Authentication and access controls;</li>
									<li>Encryption during transmission;</li>
									<li>Restricted access to systems and databases;</li>
									<li>Security monitoring;</li>
									<li>Server and infrastructure security;</li>
									<li>Secure software development practices;</li>
									<li>Logging and auditing; and</li>
									<li>Backup and recovery procedures.</li>
								</ul>

								<p>
									However, no electronic storage or transmission system can be
									guaranteed to be completely secure.
								</p>
							</section>

							<section>
								<h2>11. Data Retention</h2>

								<p>
									We retain personal information only for as long as reasonably
									necessary for the purposes described in this Privacy Policy.
								</p>

								<p>
									The retention period may depend on:
								</p>

								<ul>
									<li>The purpose for which the information was collected;</li>
									<li>The nature of the information;</li>
									<li>
										Whether the information is associated with an active
										customer order or service record;
									</li>
									<li>Business and operational requirements;</li>
									<li>Legal and regulatory requirements;</li>
									<li>Accounting requirements;</li>
									<li>Security and fraud-prevention requirements; and</li>
									<li>The resolution of disputes or legal claims.</li>
								</ul>

								<p>
									When information is no longer required, we may delete, anonymize,
									or securely dispose of it, subject to applicable legal,
									regulatory, and legitimate business requirements.
								</p>

								<p>
									Location information associated with technician and field-service
									activities is retained only for as long as reasonably necessary
									for operational, contractual, audit, security, legal, or
									dispute-resolution purposes.
								</p>
							</section>

							<section>
								<h2>12. Account and Personal Data Requests</h2>

								<p>
									If you have an account with us, you may contact us to request
									appropriate access to, correction of, or deletion of personal
									information associated with your account, subject to applicable
									laws and legitimate business requirements.
								</p>

								<p>
									Where appropriate, we may request information necessary to
									verify your identity before processing a request.
								</p>

								<p>
									Some information may need to be retained where required by law
									or where reasonably necessary for:
								</p>

								<ul>
									<li>Legal compliance;</li>
									<li>Accounting;</li>
									<li>Security;</li>
									<li>Fraud prevention;</li>
									<li>Dispute resolution; or</li>
									<li>
										Establishment, exercise, or defense of legal claims.
									</li>
								</ul>
							</section>

							<section>
								<h2>13. Employee and Field-Service Users</h2>

								<p>
									The mobile application may be provided to employees, contractors,
									field-service personnel, or other authorized users for business
									purposes.
								</p>

								<p>
									For such users, information generated through the application may
									be associated with their assigned work activities.
								</p>

								<p>
									This may include:
								</p>

								<ul>
									<li>Assigned orders;</li>
									<li>Customer visits;</li>
									<li>Installation activities;</li>
									<li>Service activities;</li>
									<li>Work status;</li>
									<li>Visit timestamps;</li>
									<li>Service documentation; and</li>
									<li>Location information associated with assigned work.</li>
								</ul>

								<p>
									Authorized Rupin Consultancy personnel may access this information
									for legitimate operational and business purposes.
								</p>

								<p>
									The use of the application does not change any employment
									agreement, employment policy, or other contractual arrangement
									between an employee and their employer.
								</p>
							</section>

							<section>
								<h2>14. Third-Party Services</h2>

								<p>
									Our website or mobile application may use third-party
									technologies, APIs, software development kits, infrastructure
									providers, or other services.
								</p>

								<p>
									Third-party services may process information in accordance with
									their own terms and privacy policies.
								</p>

								<p>
									We take reasonable steps to select service providers that
									maintain appropriate security and privacy practices for the
									services they provide to us.
								</p>
							</section>

							<section>
								<h2>15. International Data Processing</h2>

								<p>
									Depending on the infrastructure and service providers used to
									operate our Services, personal information may be stored or
									processed in India or other jurisdictions.
								</p>

								<p>
									Where personal information is processed outside India or the
									jurisdiction in which it was collected, we take reasonable steps
									to apply appropriate safeguards consistent with applicable legal
									requirements.
								</p>
							</section>

							<section>
								<h2>16. Children's Privacy</h2>

								<p>
									Our Services are intended for adults and authorized business
									users, including employees, field-service personnel, and
									customers.
								</p>

								<p>
									Our mobile application is not directed toward children.
								</p>

								<p>
									We do not knowingly collect personal information from children
									for the purpose of providing our business services.
								</p>

								<p>
									If you believe that a child has provided personal information to
									us, please contact us so that we can investigate and take
									appropriate action.
								</p>
							</section>

							<section>
								<h2>17. Third-Party Links</h2>

								<p>
									Our website or Services may contain links to websites or services
									operated by third parties.
								</p>

								<p>
									We are not responsible for the privacy practices, security, or
									content of third-party websites or services.
								</p>

								<p>
									We recommend reviewing the privacy policies of third-party
									services before providing them with personal information.
								</p>
							</section>

							<section>
								<h2>18. Your Choices</h2>

								<p>
									Depending on the feature and device you use, you may have choices
									regarding:
								</p>

								<ul>
									<li>Location permissions;</li>
									<li>Background location permissions;</li>
									<li>Camera permissions;</li>
									<li>Notification permissions;</li>
									<li>Storage or file permissions; and</li>
									<li>Other device permissions.</li>
								</ul>

								<p>
									You can generally manage these permissions through your device
									settings.
								</p>

								<p>
									If you disable location or background location permissions,
									Rupin AI may no longer be able to provide technician tracking,
									field-service coordination, location-based visit verification,
									or other location-dependent functionality.
								</p>
							</section>

							<section>
								<h2>19. Changes to This Privacy Policy</h2>

								<p>
									We may update this Privacy Policy from time to time to reflect
									changes to:
								</p>

								<ul>
									<li>Our Services;</li>
									<li>Our business operations;</li>
									<li>Our information practices;</li>
									<li>Applicable laws and regulations; or</li>
									<li>Security and privacy requirements.</li>
								</ul>

								<p>
									When we make changes, we will update the "Last Updated" date at
									the beginning of this Privacy Policy.
								</p>

								<p>
									We encourage you to periodically review this Privacy Policy.
								</p>
							</section>

							<section>
								<h2>20. Contact Us</h2>

								<div class="contact">

									<p>
										If you have questions, concerns, or requests regarding this
										Privacy Policy or the way we handle personal information,
										please contact us.
									</p>

									<p>
										<strong>Website:</strong>
										<a href="https://rupin.ai/">
											rupin.ai
										</a>
										<br />

										<strong>Email:</strong>
										<a href="mailto:info@rupin.ai">
											info@rupin.ai
										</a>
									</p>

									<p>
										For privacy-related requests, please provide sufficient
										information for us to identify the relevant account or
										request.
									</p>

								</div>
							</section>
							<section>
								<h2>21. Consent and Acknowledgement</h2>

								<p>
									By using our website, mobile application, or Services, you
									acknowledge that you have read and understood this Privacy
									Policy.
								</p>

								<p>
									Where required, we will request the relevant device permissions
									or other consent before accessing information such as location,
									camera, or other sensitive device data.
								</p>

								<p>
									Location permissions are controlled by the operating system of
									your device. You may grant, deny, or subsequently revoke
									location permissions through your device settings, subject to
									the effect that disabling such permissions may have on
									location-dependent features.
								</p>
							</section>
							</div>

						</div>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
}
